import Immutable from 'immutable';

const initialState = Immutable.fromJS(window && window.LANGUAGES ? window.LANGUAGES : {});

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    default: return state;
    }
}
